import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    Grid,
    Button,
    Dialog,
    Slide,
    Checkbox,
    FormGroup,
    FormControlLabel,
    AppBar, Toolbar, CircularProgress,MenuItem,
    Typography, IconButton, Paper, Card, CardContent, CardMedia, TextField
} from '@material-ui/core';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import Stack from '@mui/material/Stack';
import CloseIcon from '@material-ui/icons/Close';
import AUTO_COMPLET_TYPE from '../../shared/constants/autoCompleteType';
import ItemAutoComplete from '../../shared/components/ItemAutoComplete';
import DirectionsIcon from '@material-ui/icons/Directions';
import { useSelector, useDispatch } from 'react-redux';
import { getItemById } from '../../redux/actions/item/ItemAction';
import { social, SOCIAL as _SOCIAL } from '../../shared/constants/social';
import { publish_type } from '../../shared/constants/publishType';
import { LoadingButton } from '@mui/lab';
// import LoadingButton from '@mui/lab/LoadingButton';
import { Alert } from '@mui/material'
import {
    makePublishToDb,
    makeWhatsAppPublish,
    makeInstagramPublish,
    makeFacebookPublish, makeTelegramPublish
} from "../../redux/slices/publish";
// import FacebookIcon from '@mui/icons-material/Facebook';
import usePublications from "../../hooks/usePublications";
// import {SOCIAL_ICONS} from "../../shared/constants/social";
import { SOCIAL_ICONS } from './../../shared/constants/social';


const useStyles = makeStyles((theme) => ({
    root: {
        margin: '0 auto',
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minWidth: 500
    },
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
        color: 'white'
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function PublishList({ handleClose, updateItem }) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [value, setValue] = React.useState(new Date());
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const { isLoading, items } = useSelector((state) => state.item);
    const { db, facebook, telegram, whatsapp, instagram } = useSelector((state) => state.publish);
    const { item } = useSelector((state) => state.item);
    const { reset } = usePublications();
    const [desc, setDesc] = useState( updateItem?.Description  || item[0]?.Description);
    const [isAvalable, setIsAvalable] = useState(false);
    const [pubType, setBupType] = useState("");
    const [state, setState] = React.useState({
        Instagram: false,
        Facebook: false,
        WhatsApp: false,
        Telegram: false,
    });

    useEffect(()=>{
        setSelected(updateItem);
        if (updateItem?.ProductId) {
            dispatch(getItemById(updateItem.ProductId));
        }
    },[updateItem, dispatch])


    console.log(items)


    useEffect(() => {
       setIsAvalable(desc && desc?.trim() !== "" && items[0]?.ImageUrl && items[0]?.ImageUrl !== "")
    },[items, desc]);

    const handleChange = (newValues) => {
        setSelected(newValues);
        if (newValues?.id) {
            dispatch(getItemById(newValues.id));
        }
    }

    const handleSocialChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const handleSubmit = () => {
        const _item = items[0];
        let data = {
            imageUrl: _item?.ImageUrl,
            Description: desc,
        };

        setLoading(true);

        if (pubType === "Publier") {
            if (state.Facebook) {
                dispatch(makeFacebookPublish(data));
            }

            if (state.Instagram) {
                dispatch(makeInstagramPublish(data));
            }

            if (state.Telegram) {
                dispatch(makeTelegramPublish(data));
            }

            if (state.WhatsApp) {
                dispatch(makeWhatsAppPublish(data));
            }
        }

        if (pubType === "Planifier") {
            console.log(value)
            data = { ...data, planification: value };
            console.log(data)
        }

        dispatch(makePublishToDb({
            ...data, platforms: state, publishType: pubType, Title: selected.name, ProductId: selected.id
        }, reset));

    }

    useEffect(() => {
        if (!db.isLoading && !facebook.isLoading && !telegram.isLoading && !instagram.isLoading && !whatsapp.isLoading) {
            setLoading(false);
        }
    }, [db.isLoading, facebook.isLoading, telegram.isLoading, instagram.isLoading, whatsapp.isLoading])


    return (
        <Dialog fullScreen open onClose={handleClose} TransitionComponent={Transition}  >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <Typography variant="h6" className={classes.title}>
                        Formulaire de Publication
                    </Typography>
                    <IconButton color="inherit" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Button autoFocus color="inherit" onClick={handleClose}>
                        retour
                    </Button>
                </Toolbar>
            </AppBar>

            <Box style={{ margin: '0 auto' }}>

                <Box style={{ marginTop: 20, marginBottom: 20 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={8} md={8}>
                            <Paper className={classes.root} elevation={5}>
                                <ItemAutoComplete type={AUTO_COMPLET_TYPE.signle} size="small" onChange={handleChange} />
                                <IconButton color="primary" className={classes.iconButton}
                                    aria-label="vider">
                                    <DirectionsIcon />
                                </IconButton>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>

                <Stack sx={{ m: 4 }} spacing={1}>
                    {facebook?.error &&
                        <Alert severity="error"> FACEBOOK: {facebook.error?.message} </Alert>
                    }
                    {facebook?.isSucces &&
                        <Alert severity="success"> FACEBOOK: Plublier avec succes </Alert>
                    }
                    {telegram?.error &&
                        <Alert severity="error"> TELEGRAM: {telegram.error?.message} </Alert>
                    }
                    {telegram?.isSucces &&
                        <Alert severity="success"> TELEGRAM: Plublier avec succes </Alert>
                    }
                    {instagram?.error &&
                        <Alert severity="error"> INSTAGRAM: {instagram.error?.message} </Alert>
                    }
                    {instagram?.isSucces &&
                        <Alert severity="success"> INSTAGRAM: Plublier avec succes </Alert>
                    }
                    {whatsapp?.error &&
                        <Alert severity="error">WHATSAPP: {whatsapp.error?.message} </Alert>
                    }
                    {whatsapp?.isSucces &&
                        <Alert severity="success">WHATSAPP: Plublier avec succes </Alert>
                    }
                    {db?.error &&
                        <Alert severity="error"> DOLLARSTORE: {db.error?.message} </Alert>
                    }
                    {db?.isSucces &&
                        <Alert severity="success"> DOLLARSTORE: Sauvegarder avec succes </Alert>
                    }
                </Stack>

                {!isLoading ? <Grid container spacing={2}>
                    <Grid item>
                        {selected &&
                            !isLoading &&
                            <Card style={{ maxWidth: 420 }}>
                                <CardMedia
                                    style={{ height: "400px", width: "400px" }}
                                    component="img"
                                    height="400"
                                    image={items[0]?.ImageUrl}
                                    alt=" "
                                />
                            </Card>
                        }
                    </Grid>

                    <Grid item>
                        {selected &&
                            !isLoading &&
                            <Card style={{ maxWidth: 420, minWidth: 350 }}>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        multiline
                                        label="Description"
                                        defaultValue="Contact : +22890045926
                                        Whatsapp : https://wa.me/22890045926"
                                        rowsMax={7}
                                        rows={5}
                                        onChange={(e) => setDesc(e.currentTarget.value)}
                                        value={desc}
                                    />

                                    <Box style={{ marginTop: 10 }}>
                                        <Grid container spacing={2}>
                                            <FormGroup row>
                                                {social.map((soc) => {
                                                    const isWhatsapp = soc.label === _SOCIAL.WHATSAPP
                                                    return (
                                                        <FormControlLabel
                                                            key={soc.value}
                                                            label={soc.label}
                                                            control={
                                                                <>
                                                                <Checkbox
                                                                    disabled={true && isWhatsapp }
                                                                    checked={state[`${soc.label}`]}
                                                                    onChange={handleSocialChange}
                                                                    name={soc.label}
                                                                    color="primary"
                                                                  
                                                                />
                                                                <img  alt="" src={SOCIAL_ICONS[soc.label]}  style={{height: 30, width: 30}}/>
                                                                </>
                                                            }
                                                        />
                                                    )
                                                })}
                                            </FormGroup>
                                        </Grid>
                                    </Box>

                                    <Box style={{ marginTop: 10 }}>
                                        <TextField
                                            variant="outlined"
                                            select
                                            label="Type de publication"
                                            value={pubType}
                                            fullWidth
                                            onChange={(e) => setBupType(e.target.value)}
                                        >
                                            {publish_type.map((pub) => (
                                                <MenuItem key={pub.value} value={pub.value}> {pub.label} </MenuItem>
                                            ))}
                                        </TextField>
                                        <div className={classes.root}
                                            style={{ marginTop: 20, justifyContent: "center", margin: "auto" }}>
                                            {pubType === publish_type[2].value &&
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <Stack spacing={3}>
                                                        <DatePicker
                                                            views={['day']}
                                                            label="Planification "
                                                            value={value}
                                                            variant="outlined"
                                                            onChange={(newValue) => {
                                                                setValue(newValue);
                                                                console.log(value)
                                                            }}
                                                            renderInput={(params) => <TextField {...params} helperText={null} />}
                                                        />
                                                    </Stack>
                                                </LocalizationProvider>}
                                        </div>
                                    </Box>

                                    <Box style={{ marginTop: 10, display: "flex", justifyContent: "flex-end" }}>
                                        <LoadingButton type="submit" color="primary" variant="contained"
                                            onClick={handleSubmit} loading={loading} disabled={!isAvalable} > 
                                            Valider
                                        </LoadingButton>
                                    </Box>
                                </CardContent>
                            </Card>
                        }
                    </Grid>
                </Grid> :
                    <CircularProgress size={40} style={{ margin: "0 auto" }} />
                }

            </Box>
        </Dialog>
    );
}